import { render } from "./All-Prints.vue?vue&type=template&id=1a26821d&scoped=true"
import script from "./All-Prints.vue?vue&type=script&lang=js"
export * from "./All-Prints.vue?vue&type=script&lang=js"

import "./All-Prints.vue?vue&type=style&index=0&id=1a26821d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a26821d"]])

export default __exports__